module.exports = __webpack_public_path__ + "static/media/37.b2910a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/37.png
// module id = 405
// module chunks = 0